import React from "react";

export default function AddWishListThemeLine({params}) {

    if (params.states.isEx) {
        return <a onClick={params.actions.remove.bind(this)} className="basket-item-action-item" href="#">Убрать из избранного</a>;
    }

    return <a onClick={params.actions.handleClick.bind(this)} className="basket-item-action-item" href="#">В избранное</a>;
}